import React from "react";
import { Container, PrimaryButton, Overline } from "@/components/primitives";

export default function NotFound() {
  return (
    <Container className="flex min-h-[60vh] flex-col justify-center py-24">
      <Overline accent>Error 404</Overline>
      <h1 className="mt-5 font-display text-5xl font-semibold tracking-tight md:text-7xl">
        This page is off the roadmap.
      </h1>
      <p className="mt-5 max-w-lg text-lg text-muted-foreground">
        The page you were looking for does not exist. Head back to the autonomy hub.
      </p>
      <div className="mt-10">
        <PrimaryButton to="/" testid="notfound-home-btn">
          Back to home
        </PrimaryButton>
      </div>
    </Container>
  );
}
